/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Preset_LabelInputs */

const en_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Preset`)
};

const fr_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage de style`)
};

const de_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilvoreinstellung`)
};

const it_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione di stile`)
};

const ru_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданный стиль`)
};

const es_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste preestablecido de estilo`)
};

const zh_cn2_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风格预设`)
};

const ja_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルプリセット`)
};

const hi_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल प्रीसेट`)
};

const pt_pt2_video_export_style_preset_label = /** @type {(inputs: Video_Export_Style_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição de estilo`)
};

/**
* | output |
* | --- |
* | "Style Preset" |
*
* @param {Video_Export_Style_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_preset_label = /** @type {((inputs?: Video_Export_Style_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_style_preset_label(inputs)
	if (locale === "de") return de_video_export_style_preset_label(inputs)
	if (locale === "it") return it_video_export_style_preset_label(inputs)
	if (locale === "ru") return ru_video_export_style_preset_label(inputs)
	if (locale === "es") return es_video_export_style_preset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_style_preset_label(inputs)
	if (locale === "ja") return ja_video_export_style_preset_label(inputs)
	if (locale === "hi") return hi_video_export_style_preset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_style_preset_label(inputs)
	return en_video_export_style_preset_label(inputs)
});